import React, { useEffect, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setIsAutoLogin, setLogin } from 'redux/actions/authActions';
import { changeDefaultLanguage } from 'redux/actions/topBarActions';
import { changeTheme, setClientLink } from 'redux/actions/themeActions';
import useApi from 'hooks/useApi';
import MainSpinner from 'shared/components/MainSpinner';

import { AutoLoginWrapper } from './styles';

const AutoLogin = () => {
  const { token } = useParams();
  const { i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { isAutoLogin } = useSelector((state) => state.auth);
  const { customAreaApi } = useApi();

  const [, getAutoLogin] = customAreaApi(
    {
      url: `${window.API_V1}/login/autologin`,
      method: 'POST',
    },
    { manual: true }
  );

  const onAutoLogin = useCallback(async () => {
    if (!isAutoLogin) {
      try {
        const {
          data: { data },
        } = await getAutoLogin({
          data: token,
        });
        const { config, relations } = data;
        dispatch(setIsAutoLogin(true));
        if (config != null && Object.keys(config).length > 0) {
          dispatch(setLogin(data));
          i18n.changeLanguage(data.i18);
          dispatch(changeDefaultLanguage(data.i18));
          if (relations) {
            const existClientLink = relations.some((x) => x === 'clientlink');
            dispatch(setClientLink(existClientLink));
          }
          dispatch(changeTheme(config));
          history.push('/home');
        }
      } catch (error) {
        if (error.response) {
          history.push('/log_in');
        }
      }
    }
  }, [isAutoLogin]);

  useEffect(() => {
    if (!isAutoLogin) {
      const callAutoLogin = () => {
        onAutoLogin();
      };
      callAutoLogin();
    }
  }, [isAutoLogin]);

  return <AutoLoginWrapper>{!isAutoLogin && <MainSpinner />}</AutoLoginWrapper>;
};

export default AutoLogin;
